module.exports = __webpack_public_path__ + "img/count-01.5adbafc3.png";